import React, { useEffect, useState } from "react";
import "./header.css";
import { Link } from "react-scroll";
import { Link  as Link2} from "react-router-dom";


import AOS from "aos";
import "aos/dist/aos.css";


function Header() {
  const [show, handleShow] = useState(false);

  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.scrollY > 50) {
        handleShow(true);
      } else handleShow(false);
    });
    return () => {
      window.removeEventListener("scroll", () => {
        if (window.scrollY < 100) {
          // do this
          handleShow(false);
        } else handleShow(true);
      });
    };
  }, []);


  useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, []);

  return (
    <div className={`header ${show && "header-dark"}`}>
      <Link2 className="logo" to="/" data-aos={"fade-down"}><div>SM</div></Link2>
      <div className="nav-item">
        <Link
          activeClass="active"
          to="about"
          spy={true}
          smooth={true}
          duration={650}
          data-aos-delay="300"
          data-aos={"fade-down"}
        >
          <a href="#about" >
            <span>01.</span> About
          </a>
        </Link>

        <Link
          activeClass="active"
          to="exp"
          spy={true}
          smooth={true}
          duration={650}
          data-aos={"fade-down"} data-aos-delay="400"
        >
          <a href="#exp" >
            <span>02.</span> Experience
          </a>
        </Link>

        <Link
          activeClass="active"
          to="project"
          spy={true}
          smooth={true}
          duration={650}
          data-aos={"fade-down"} data-aos-delay="500"
        >
          <a>
            <span>03.</span> Project
          </a>
        </Link>

        <Link
          activeClass="active"
          to="contact"
          spy={true}
          smooth={true}
          duration={1000}
          data-aos={"fade-down"} data-aos-delay="600"
        >
          <a>
            <span>04.</span> Contact
          </a>
        </Link>

        <a className="nav-item-main" data-aos={"fade-down"} data-aos-delay="700">Resume</a>
      </div>
    </div>
  );
}

export default Header;
